import { TRANSLATION_STORIES_LIST } from '../translations/stories';
import { IDropzoneValidator } from './../interfaces/fileUploaderContainer';
import {
  CATEGORY_ALL,
  CATEGORY_HIDDEN,
  CATEGORY_PERMANENT,
  CATEGORY_SCHEDULED,
  CATEGORY_VISIBLE,
  SECTIONS_ALL,
  SECTIONS_IMAGES,
  SECTIONS_VIDEOS
} from './tagManager';

export const STORIES_STATUS = {
  visible: 'visible',
  hidden: 'hidden',
  scheduled: 'scheduled',
  permanent: 'permanent'
};

export const STORIES_OPTION_FILTER = {
  allStories: {
    filter: TRANSLATION_STORIES_LIST.table.filter.all,
    gtmTag: CATEGORY_ALL,
    status: undefined
  },
  visibleStories: {
    filter: TRANSLATION_STORIES_LIST.table.filter.visible,
    gtmTag: CATEGORY_VISIBLE,
    status: STORIES_STATUS.visible
  },
  hiddenStories: {
    filter: TRANSLATION_STORIES_LIST.table.filter.hidden,
    gtmTag: CATEGORY_HIDDEN,
    status: STORIES_STATUS.hidden
  },
  scheduledStories: {
    filter: TRANSLATION_STORIES_LIST.table.filter.scheduled,
    gtmTag: CATEGORY_SCHEDULED,
    status: STORIES_STATUS.scheduled
  },
  permanentStories: {
    filter: TRANSLATION_STORIES_LIST.table.filter.permanent,
    gtmTag: CATEGORY_PERMANENT,
    status: STORIES_STATUS.permanent
  }
};

export const STORY_TYPES = {
  video: 'video',
  static: 'static'
};

export const STORIES_TYPE_MENU = [
  {
    id: 0,
    label: TRANSLATION_STORIES_LIST.table.type.all,
    value: undefined,
    gtmTag: SECTIONS_ALL
  },
  {
    id: 1,
    label: TRANSLATION_STORIES_LIST.table.type.static,
    value: STORY_TYPES.static,
    gtmTag: SECTIONS_IMAGES
  },
  {
    id: 2,
    label: TRANSLATION_STORIES_LIST.table.type.video,
    value: STORY_TYPES.video,
    gtmTag: SECTIONS_VIDEOS
  }
];

export const DEFAULT_PAGINATOR_STATE = 15;
export const DEFAULT_PAGINATOR_STATE_V3 = 150;

export const DEFAULT_STORIES_FILTER = {
  searchValue: '',
  type: STORIES_TYPE_MENU[0],
  status: STORIES_OPTION_FILTER.allStories
};

export const ORDER_ASC = 'asc';
export const ORDER_DESC = 'desc';

export const STORIES_UPLOADER_VALIDATORS: IDropzoneValidator = {
  maxFileCount: 1,
  maxFileSize: 6291456, // 6MB
  fileFormats: {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'video/mp4': ['.mp4']
  }
};

export const STORY_STATUS_STOPPED = 'stopped';

export const STORIES_ERROR_CODES = {
  UPLOAD_STORY_SERVICE_ERROR: 0,
  INVALID_FORMAT_STORY_ERROR: 53,
  MAX_SIZE_IMAGE_STORY_ERROR: 54,
  MAX_SIZE_VIDEO_STORY_ERROR: 413 //APIGatewayException max 6mb
};
